import React from 'react';
import { ContainerYardGeoGridCore } from './sections/ContainerYardGeoGridCore';
import UnifiedGeoGridPdfV2 from '../shared/UnifiedGeoGridPdfV2';
import { GeoGridPdfProps } from '../../shared/types/PdfTypedInterfaces';

const GeoGridResultsPdfDocumentV2: React.FC<GeoGridPdfProps> = ({ dynamicProject, projectInfo, t, geoGridData, geogridImage }) => {
    const projectType = dynamicProject?.data?.type || 'container_yard';

    // Get project type display name based on actual project type
    const getProjectTypeDisplayName = () => {
        switch (projectType) {
            case 'container_yard':
                return t('container_yard') || 'Container Yard';
            case 'parking_deck':
                return t('parking_deck') || 'Parking Deck';
            default:
                return t('project') || 'Project';
        }
    };

    return (
        <UnifiedGeoGridPdfV2
            dynamicProject={dynamicProject}
            projectInfo={projectInfo}
            t={t}
            geoGridData={geoGridData}
            geogridImage={geogridImage}
            coreComponent={ContainerYardGeoGridCore}
            defaultProjectType="container_yard"
            customTitle={t('pdf_header_technical_report_groundmac') || 'GROUNDMAC - Design Technical Report'}
            customProjectType={getProjectTypeDisplayName()}
            customSubtitle={t('subtitle_designing_geogrid') || 'Designing Geogrid'}
        />
    );
};

export default GeoGridResultsPdfDocumentV2;
